// Final Destinations
export const GET_DATA_WEATHER_FORECAST = '/weather/data';
export const GET_DATA_WEATHER_CURRENT = '/weather/current';